export default "__VITE_ASSET__CN98d0M7__"